import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import quoteIcon from "svg/quote.svg";
import { getSiteDetails } from "store/siteRepo/actionCreator";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import SelectFloorPlans from "components/siteRepo/createQuote/selectFloorPlans";
import SelectProducts from "components/siteRepo/createQuote/selectProducts";
import "./style.scss";

const CreateQuote = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { siteId } = useParams();
  const [siteData, setSiteData] = useState({});
  const [selectedFloorPlans, setSelectedFloorPlans] = useState([]);
  const [selectedFloorPlansData, setSelectedFloorPlansData] = useState([]);
  const [isShowProjectView, setIsShowProjectView] = useState(false);

  const { viewSite } = useSelector((state) => state.siteRepo);

  useEffect(() => {
    if (!(viewSite?.siteId === siteId)) {
      dispatch(getSiteDetails(siteId)).then((res) => setSiteData(res));
    } else {
      setSiteData({ ...viewSite });
    }
  }, []);

  useEffect(() => {
    let tempData = JSON.parse(JSON.stringify(viewSite));
    tempData.projectDetailsList?.map((project) => {
      project.isProjectChecked = false;
    });
    setSiteData({ ...tempData });
  }, [viewSite]);

  useEffect(() => {
    let temp = false;
    viewSite.projectDetailsList?.some((project) => {
      if (project.layerInfoList?.length > 1) {
        temp = true;
      }
    });
    setIsShowProjectView(temp);
  }, [viewSite]);

  if (location.hash === "#select-products" && selectedFloorPlans?.length === 0) {
    navigate(`/siteRepo/createQuote/${siteId}#select-floor-plans`);
  }

  const updateProjectSelection = (projectData, isProjectChecked) => {
    let tempData = JSON.parse(JSON.stringify(siteData));
    let selectedFloorPlansClone = [...selectedFloorPlans];
    let selectedFloorPlansDataClone = [...selectedFloorPlansData];
    tempData.projectDetailsList?.map((project) => {
      if (projectData.projectId === project.projectId) {
        project.isProjectChecked = isProjectChecked;
        project.layerInfoList?.length &&
          project.layerInfoList.map((layerItem, index) => {
            if (isProjectChecked) {
              if (!selectedFloorPlansClone.includes(layerItem.layerId)) selectedFloorPlansClone.push(layerItem.layerId);
              if (
                !selectedFloorPlansDataClone
                  .map((selectedFloorPlan) => selectedFloorPlan.layerId)
                  .includes(layerItem.layerId)
              ) {
                selectedFloorPlansDataClone.push({
                  ...layerItem,
                  projectName: project.name,
                  projectId: project.projectId,
                });
              }
            } else {
              if (layerItem.projectId == projectData.projectId) {
                const spliceIndex = selectedFloorPlansClone.indexOf(layerItem.layerId);
                if (spliceIndex != -1) {
                  selectedFloorPlansClone.splice(spliceIndex, 1);
                  selectedFloorPlansDataClone.splice(spliceIndex, 1);
                }
              }
            }
          });
      }
    });
    setSelectedFloorPlans(selectedFloorPlansClone);
    setSelectedFloorPlansData(selectedFloorPlansDataClone);
    setSiteData({ ...tempData });
  };

  const updateLayerSelection = (layer, isSelectAll = undefined) => {
    const { layerId } = layer;
    let selectedFloorPlansClone = [...selectedFloorPlans];
    let selectedFloorPlansDataClone = [...selectedFloorPlansData];
    let tempData = JSON.parse(JSON.stringify(siteData));

    if (isSelectAll == undefined) {
      const currentProject = tempData.projectDetailsList.find((project) => project.projectId == layer.projectId);
      if (selectedFloorPlans.includes(layerId)) {
        const spliceIndex = selectedFloorPlansClone.indexOf(layerId);
        selectedFloorPlansClone.splice(spliceIndex, 1);
        selectedFloorPlansDataClone.splice(spliceIndex, 1);
        //Clear project all selected
        currentProject.isProjectChecked = false;
      } else {
        //Check for all layers selected
        selectedFloorPlansClone.push(layerId);
        selectedFloorPlansDataClone.push(layer);
        if (
          selectedFloorPlansClone.length > 0 &&
          currentProject.layerInfoList
            .map((layerInfo) => layerInfo.layerId)
            .every((id) => selectedFloorPlansClone.includes(id))
        ) {
          currentProject.isProjectChecked = true;
        } else {
          currentProject.isProjectChecked = false;
        }
      }
    } else {
      if (isSelectAll) {
        selectedFloorPlansClone = [];
        selectedFloorPlansDataClone = [];
        tempData?.projectDetailsList?.map((project) => {
          project.isProjectChecked = true;
          project.layerInfoList?.length &&
            project.layerInfoList.map((layerItem, index) => {
              selectedFloorPlansClone.push(layerItem.layerId);
              selectedFloorPlansDataClone.push({
                ...layerItem,
                projectName: layerItem.projectName,
                projectId: project.projectId,
              });
            });
        });
      } else {
        tempData.projectDetailsList?.map((project) => {
          project.isProjectChecked = false;
        });
        selectedFloorPlansClone = [];
        selectedFloorPlansDataClone = [];
      }
    }
    setSiteData({ ...tempData });
    setSelectedFloorPlans(selectedFloorPlansClone);
    setSelectedFloorPlansData(selectedFloorPlansDataClone);
  };

  const contentProps = {
    siteData,
    selectedFloorPlans,
    updateLayerSelection,
    updateProjectSelection,
    selectedFloorPlansData,
    isShowProjectView,
  };

  return (
    <div className="create-quote container-fluid search-form-container">
      <div className="search-form-container__title d-flex align-items-center">
        <img src={quoteIcon} alt="" className="me-2" />
        <span className="search-form-container__title--text">Create Quote</span>
      </div>
      <Tabs
        transition={false}
        activeKey={location.hash}
        onSelect={(key) => navigate(`/siteRepo/createQuote/${siteId}${key}`)}
      >
        <Tab eventKey="#select-floor-plans" title="Select Floor Plans" mountOnEnter>
          <SelectFloorPlans {...contentProps} />
        </Tab>
        <Tab
          eventKey="#select-products"
          title="Select Products"
          disabled={selectedFloorPlans?.length === 0}
          mountOnEnter
        >
          <SelectProducts {...contentProps} />
        </Tab>
      </Tabs>
    </div>
  );
};

export default CreateQuote;
